module.exports = __webpack_public_path__ + "static/media/Home Page_website-05.0d9d2d25.png";